import { Helmet } from "react-helmet";
import BayanListPage from "../BayanList/BayanListPage";

const SundayBayanComponent = () => {
  return (
    <>
      <Helmet>
        <meta
          name="description"
          content="Explore the latest Morning bayanats from our mosque. Listen to inspiring bayans delivered daily, available for easy accessibility on our website."
        />
        <title>Latest Morning Bayans | Mosque Audio</title>
      </Helmet>

      <BayanListPage
        apiType="morningdars"
        pageTitle="Morning Dars Bayan"
        pageSubtitle="Daily Audio Listening"
        countPerPage={12}
      />
    </>
  );
};

export default SundayBayanComponent;
